import {atom} from "recoil";
import {ReactNode} from "react";

export const ModalState = atom({
    key: 'model',
    default: {open: false} as {open: boolean, modalComponent?: ReactNode}
})